// This file serves as the single source of truth for category names
export const CATEGORY_NAMES = {
  MOTOR_SKILLS: "Motor Skills",
  LANGUAGE_SKILLS: "Language Skills",
  COGNITIVE_DEVELOPMENT: "Cognitive Development",
  INDEPENDENT_SKILLS: "Independent Skills",
  SOCIAL_EMOTIONAL: "Social and Emotional Skills",
} as const;

export type CategoryName = typeof CATEGORY_NAMES[keyof typeof CATEGORY_NAMES];

// Use this to get all categories in array format
export const getAllCategories = () => Object.values(CATEGORY_NAMES);

// Validate if a string is a valid category name
export const isValidCategory = (category: string): category is CategoryName => {
  return Object.values(CATEGORY_NAMES).includes(category as CategoryName);
};

// Map database category names to display names
export const mapDatabaseToDisplayCategory = (dbCategory: string): string => {
  const categoryMap: Record<string, string> = {
    "Language Development": CATEGORY_NAMES.LANGUAGE_SKILLS,
    "Language Skills": CATEGORY_NAMES.LANGUAGE_SKILLS,
  };
  
  return categoryMap[dbCategory] || dbCategory;
};

// Map display names to database category names
export const mapDisplayToDatabaseCategory = (displayCategory: string): string => {
  const categoryMap: Record<string, string> = {
    [CATEGORY_NAMES.LANGUAGE_SKILLS]: "Language Skills",
  };
  
  return categoryMap[displayCategory] || displayCategory;
};